module.exports = __webpack_public_path__ + "ff21e8d8fcc120dca62dc41ecb69aec6.MP3";